import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { forkJoin } from 'rxjs';
import { PettyCashBox, PettyCashDocument, PettyCashService } from '../../accounts/workforce-cash/petty-cash.service';
import { PermissionService } from '../../security/permission.service';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({ selector: 'app-petty-cash-voucher', standalone: true, imports: [CommonModule, RouterModule, ButtonModule],
  templateUrl: './petty-cash-voucher.component.html', styleUrls: ['./petty-cash-voucher.component.css'] })
export class PettyCashVoucherComponent implements OnInit {
  document?: PettyCashDocument; box?: PettyCashBox; error = ''; loading = true;
  constructor(private petty: PettyCashService, private route: ActivatedRoute, private session: SessionStorageService,
    private permissions: PermissionService) {}
  ngOnInit(): void {
    const company = this.session.getCompany()?.id, id = Number(this.route.snapshot.paramMap.get('id'));
    if (!company || !id) { this.error = 'Choose a company and cash voucher.'; this.loading = false; return; }
    const finance = this.permissions.hasPermission('accounts.petty-cash.boxes.manage')
      || this.permissions.hasPermission('accounts.workforce-finance.recoveries.confirm');
    forkJoin({ document: finance ? this.petty.financeVoucher(company, id) : this.petty.myVoucher(company, id),
      boxes: finance ? this.petty.boxes(company) : this.petty.myBoxes(company) }).subscribe({
      next: ({ document, boxes }) => { this.document = document; this.box = boxes.find(box => box.pettyCashBoxId === document.pettyCashBoxId); this.loading = false; },
      error: err => { this.error = err?.error?.message || 'Posted cash voucher could not be loaded.'; this.loading = false; }
    });
  }
  get inflow(): boolean { return ['FUND', 'FLOAT_RETURN', 'PAY_ADVANCE_REPAY', 'EARNED_PAY_RETURN'].includes(this.document?.purpose || ''); }
  get backLink(): string { return this.permissions.hasPermission('accounts.petty-cash.boxes.manage')
    || this.permissions.hasPermission('accounts.workforce-finance.recoveries.confirm')
      ? '/accounts/enterprise/workforce-finance' : '/workspace/petty-cash'; }
  get counterparty(): string { const doc = this.document;
    return doc?.payeeName || (doc?.fieldWorkerId ? `Worker #${doc.fieldWorkerId}` : doc?.bankAccountId ? `Company bank account #${doc.bankAccountId}` : 'Cash recipient'); }
  money(value?: number): string { return Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  print(): void { window.print(); }
}
